/**
 * Checks to see if 2 values are equal (with support for deeply nested Objects and Arrays).
 */
export { default as deepEqual } from 'fast-deep-equal';